<template>
    <div
        ref="districtVideoHolder"
        class="content-widget no-max-height "
        :class="{'is-playing': isPlaying,
                 'video-widget': !$attrs.standalone
                }"
    >
        <a
            href="#"
            class="btn-play__cover"
            @click.prevent="playVideo();"
        >
            <span class="btn-play">
                <img
                    src="@/assets/images/play_btn.svg"
                    alt="play button image"
                    width="82"
                    height="96"
                    class="btn-play__img"
                >
            </span>
        </a>
    </div>
</template>

<script>
    import { EventBus } from '@/event-bus';
    import Http from '@/api/data';
    import { mapActions, mapGetters } from 'vuex';
    import VideoPlayerMixin from '@/mixins/VideoPlayerMixin';
    import TrackingService from '@/services/TrackingService';

    export default {
        name: 'DistrictVideo',
        mixins: [VideoPlayerMixin],
        props: [
            'link',
            'active'
        ],
        data () {
            return {
                isPlaying: false,
                widget: null
            };
        },
        computed: {
            ...mapGetters([
                'isReviewUse',
                'language',
                'protocol',
            ]),
            apiUrl() {
                return 'https://' + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            }
        },
        mounted() {
            this.render();
        },
        methods: {
            ...mapActions([
                'setIsLoading'
            ]),
            playVideo() {
                if (this.widget) {
                    this.isPlaying = true;
                    this.widget.resume();
                }
            },
            render() {
                let urlLink = this.$props.link ? this.$props.link : this.apiUrl + '/request-data/district-video' + window.location.search;
                if (this.language && !urlLink.includes('&language'))
                    urlLink += '&language=' + this.language;
                Http.getData(urlLink).then(payload => {
                    if (payload) {
                        payload.isInternal = this.isInternal;
                        if (payload.language)
                            this.$i18n.locale = payload.language;
                        
                        // Charger Video.js avant d'initialiser le widget
                        this.loadVideoJs().then(() => {
                            this.widget = new Habiteo.VideoWidget(this.$refs.districtVideoHolder, payload);
                            this.setIsLoading(false);
                            
                            // Envoi du tracking via TrackingService
                            const trackingParams = {
                                widget_name: 'Video',
                                widget_category: 'Video',
                                view: '',
                                typo: '',
                                variante: '',
                                piece: '',
                                data: payload
                            };
                            
                            TrackingService.sendWidgetDisplay(trackingParams);
                        }).catch(error => {
                            console.error('Impossible de charger Video.js:', error);
                            EventBus.$emit('setErrorState', true, 'Impossible de charger le lecteur vidéo');
                        });
                    }
                }).catch(error => {
                    EventBus.$emit('setErrorState', true, error);
                });
            }
        },
        watch: {
            active(val) {
                if (!val)
                    if (this.widget)
                        this.widget.pause();
                else
                    if (this.isPlaying)
                        this.widget.resume();
            }
        }
    };
</script>

<style lang="scss">
    .video-js {
        .vjs-remaining-time-display {
            display: none;
        }

        .vjs-time-control {
            display: block;
        }
    }
    .no-max-height {
        max-height: none !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/DistrictVideoWidget.vue